module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "45px"
    }
  }, [_c('mt-cell-group', {
    attrs: {
      "grouppaddingleft": "0"
    }
  }, _vm._l((15), function(n) {
    return _c('mt-cell-swipe', {
      attrs: {
        "right": _vm.rightButtons,
        "wrapperpaddingleft": "20px",
        "title": "swipe me"
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-092b2d62","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/cell-swipe.vue
// module id = 110
// module chunks = 0